export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Roman-1fbe9beb107e01a0a62b2e455cf3ded6.woff";